<template>
  <div>
  <div class="right-sidebar-panel-content animated fadeInRight" tabindex="5003" style="overflow: hidden; outline: none;"></div>
  <form @submit.prevent="login">
    <section class="main" :style="{
                                    backgroundImage: `url(${back_img})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    backgroundRepeat: 'no-repeat'
                                  }">
      <div class="bottom-grid">
        <div class="logo">
          <h1> <a href="#"> {{ title }} </a></h1>
        </div>
      </div>
      <div class="content-w3ls">
        <div class="text-center icon">          
          <img :src="logo_img" style="height:120px;"/>
        </div>
        <div class="content-bottom">
          <div class="field-group">
            <span class="fa fa-user" aria-hidden="true"></span>
            <div class="wthree-field">
              <input name="text1" id="text1" type="text" autocomplete='false' v-model="id" placeholder="使用者帳號" required>
            </div>
          </div>
          <div class="field-group">
            <span class="fa fa-lock" aria-hidden="true"></span>
            <div class="wthree-field" style="position: relative; width: 100%;">
              <input :type="type" id="myInput" v-model="pwd" placeholder="使用者密碼" required style="width: 100%; padding-right: 40px; box-sizing: border-box;">
              <span @click="switchVisibility(0)" style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); cursor: pointer; width: 24px; text-align: center; z-index: 10;">
                  <img v-if="type === 'password'" src="img/icon/eye-solid.svg" width="20px"/>
                  <img v-else src="img/icon/eye-closed.svg" width="20px"/>
              </span>
            </div>
          </div>
          <div class="wthree-field">
            <button type="submit" class="btn">登入</button>
          </div>
          <ul class="list-login">
            <li class="switch-agileits">
              <label class="switch">
                <input type="checkbox" v-model="isRember">
                  <span class="slider round"></span>
                    Remember ID
              </label>
            </li>
            <li>
              <a href="#" class="text-right"> 忘記密碼 ?</a>
            </li>
            <li class="clearfix"></li>
          </ul>
        </div>
        <ejs-toast ref='toastRef' id='toast_type' :position='position'></ejs-toast>      
      </div>
      <div class="copyright">
        <p>© {{ new Date().getFullYear() }} V{{ version }} Design by <a href="http://www.gfnnet.com">Smart Service Co., Ltd.</a></p>
      </div>
      <div class="control-section">
        <ejs-dialog ref="modalPwdDialog" :showCloseIcon='true' :isModal='true' :closeOnEscape='true' :visible='false' header='首次登入請更改密碼' :buttons='dialog_buttons' 
            width='400px'>
            <div formGroup="orderForm">                   
                <div class="form-row">
                    <div class="form-group col-md-12">
                        <ejs-textbox id='txtpwd' floatLabelType="Auto" placeholder="請輸入密碼" :type="type1" v-model="e_pwd" aria-required="true" style="width: 100%; padding-right: 40px; box-sizing: border-box;"></ejs-textbox>   
                        <span @click="switchVisibility(1)" style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); cursor: pointer; width: 24px; text-align: center; z-index: 10;">
                          <img v-if="type1 === 'password'" src="img/icon/eye-solid.svg" width="20px"/>
                          <img v-else src="img/icon/eye-closed.svg" width="20px"/>
                        </span>
                    </div> 
                    <div class="form-group col-md-12">
                        <ejs-textbox id='txtpwd2' floatLabelType="Auto" placeholder="再次確認密碼" :type="type2" v-model="e_pwd2" aria-required="true" style="width: 100%; padding-right: 40px; box-sizing: border-box;"></ejs-textbox>    
                        <span @click="switchVisibility(2)" style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); cursor: pointer; width: 24px; text-align: center; z-index: 10;">
                          <img v-if="type2 === 'password'" src="img/icon/eye-solid.svg" width="20px"/>
                          <img v-else src="img/icon/eye-closed.svg" width="20px"/>
                        </span>
                    </div>
                </div> 
            </div>                
        </ejs-dialog> 
      </div>
    </section>
  </form>
  </div>  
  
</template>
<script>

  import Vue from "vue";
  import Loading from 'vue-loading-overlay';
  import logoImg from '../../../public/img/avatars/logo2.png';  
  import backImg from '../../../public/img/avatars/bg.png';  
  import { DialogPlugin } from '@syncfusion/ej2-vue-popups';  
  import { ToastComponent } from "@syncfusion/ej2-vue-notifications";
  import { TextBoxPlugin } from '@syncfusion/ej2-vue-inputs';


  Vue.use(Loading);
  Vue.use(DialogPlugin);
  Vue.use(TextBoxPlugin);

  let loader = undefined;

  export default {
    name: 'Login',
    components: {   
      'ejs-toast': ToastComponent,
    },
    data () {
      return {
        version: process.env.VUE_APP_VERSION,
        isRember: localStorage.getItem('isRember'),
        id: localStorage.getItem('isRember') ? localStorage.getItem('userid') : '',        
        pwd: null, e_pwd: "", e_pwd2: "",
        logo_img : logoImg, back_img : backImg,
        position: { X: 'Right', Y: "Bottom" }, ShowBtn: false,
        dialog_buttons: [{
          click: this.dialog_editOkClick,
          buttonModel: { content: '確認更改密碼', isPrimary: true } 
        }, { 
          click: function() { this.hide(); }, 
          buttonModel: { content: '取消', isPrimary: false}
        }],         
        title: Vue.prototype.GLOBAL.sysType == 'SCM' ? '百家珍食品-供應鏈管理平台' : '百家珍食品-工作站管理平台',
        type: 'password', type1: 'password', type2: 'password',
      }
    },
    methods: {
      switchVisibility(target) {
        if (target === 0) {
          this.type = this.type === 'password' ? 'text' : 'password';
        } else if (target === 1) {
          this.type1 = this.type1 === 'password' ? 'text' : 'password';
        } else if (target === 2) {
          this.type2 = this.type2 === 'password' ? 'text' : 'password';
        }
      },
      login: function () {  
        this.showLoading();
        this.axios({
            method: 'post',
            baseURL: Vue.prototype.GLOBAL.baseURL,
            url: Vue.prototype.GLOBAL.sysType == 'SCM' ? 'SCM/Login' : 'Account/Login', 
            headers: {'Content-Type' : 'application/json'},
            data : {
              id: this.id,
              pwd: this.pwd
            }
        })
        .then((response) => {       
          if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); this.hideLoading(); return; } 
          this.hideLoading();       
          localStorage.setItem('isRember',  this.isRember);  
          localStorage.setItem('userid',    this.isRember ? this.id : '' );       
          localStorage.setItem('token',     response.data.datas.ticket);                
          localStorage.setItem('name',      response.data.datas.name);
          localStorage.setItem('img',       response.data.datas.img_url	);
          localStorage.setItem('production',response.data.datas.production	);
          localStorage.setItem('report',    response.data.datas.report	);
          localStorage.setItem('scm',       response.data.datas.scm	);
          localStorage.setItem('system',    response.data.datas.system	);
          localStorage.setItem('workstation', response.data.datas.workstation	);
          this.GetLimitapi();
          if (response.data.datas.change_pwd) {
            this.$refs.modalPwdDialog.show();
            return;
          }
          this.$router.push('/')   
        
        })
        .catch((error) => { this.showError(error, true) }

        )               
      },
          GetLimitapi() {
      this.axios({
          method:'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url:`/Limit`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }
        this.str =response.data.datas
        // console.log(response.data.datas)
        // this.$options.nav = [JSON.parse(this.str)];
        //TODO
        localStorage.setItem('limit', this.str);
        
      })
      .catch((error) => { 
        this.$refs.toastRef.show( { title: '錯誤!', content: error, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' });
      })
    },
      dialog_editOkClick: function () {  
        if (this.e_pwd != this.e_pwd2) {  
          // this.e_msg = "兩者密碼不相同,請重新輸入"
          this.$refs.toastRef.show( { title: '錯誤!', content: "兩者密碼不相同,請重新輸入", cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); 
          return
        }
        this.axios({
            method: 'put',
            baseURL: Vue.prototype.GLOBAL.baseURL,
            url: Vue.prototype.GLOBAL.sysType == 'SCM' ? 'SCM/ChangePwd' : 'Account/ChangePwd',
            headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
            data : {
              pwd: this.e_pwd
            }
          })
          .then((response) => {             
            if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); this.hideLoading(); return; } 
            this.$refs.modalPwdDialog.hide();          
            this.showMsg(`密碼已修正,請重新登入`);
            this.pwd = ""; this.e_pwd = ""; this.e_pwd2 = "";
          })
          .catch((error) => {this.showError(error, true)}
        )        
      },
      showError: function (error) {     
        this.hideLoading();
        if (error.response.status == 400) {
          for(var key in error.response.data.errors){      
            this.$refs.toastRef.show( { title: '警告!', content: error.response.data.errors[key][0] , cssClass: 'e-toast-warning', icon: 'e-warning toast-icons' });           
          }
          return;
        }   
        if (error.response.status == 401) {
          localStorage.removeItem('token'); this.$router.push('/login');
          return;
        }
        this.$refs.toastRef.show( { title: '錯誤!', content: error.response.status, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' });
      },
      showMsg: function (msg) {
        this.$refs.toastRef.show( { title: '訊息!', content: msg, cssClass: 'e-toast-info', icon: 'e-info toast-icons' });
      },
      showLoading() {
        loader = this.$loading.show({
            container: this.$refs.loadingContainer,
            canCancel: true, // default false
            onCancel: this.yourCallbackMethod,
            color: 'green',
            loader: 'dots',  // spinner, dots, bars
            width: 164,
            height: 164,
            backgroundColor: 'black',
            opacity: 0.5,
            zIndex: 999,
        });
      },
      hideLoading() {
        loader.hide();
      }
    } 
  }
</script>
<style>  
</style>
<style lang="scss" src="../../scss/login.scss"></style>
<style lang="scss" src="../../scss/base.scss"></style>